// ============================================================================
// stage1-email-clean-body.ts
// ----------------------------------------------------------------------------
// The "clean body" a Stage 1 import keeps for an imported email: its text with a
// forwarded or original message, a "--" signature block and a trailing
// disclaimer cut off. It is what the import saves as the RFQ text for an email.
// Moved out of Stage1DataEntry unchanged (2026-10-21) so the covering-note
// question's tests read emails exactly as the import does; because it cuts so
// much, that question shows the email's FULL text, never this body.
// ============================================================================

export function stage1EmailCleanBody(content: unknown): string {
    let cleanBody = (typeof content === 'string' ? content : '').trim();

    // Strip forwarded email headers
    cleanBody = cleanBody.replace(/^-{3,}\s*Original Message\s*-{3,}[\s\S]*$/im, '').trim();
    cleanBody = cleanBody.replace(/^-{3,}\s*Forwarded message\s*-{3,}[\s\S]*$/im, '').trim();
    cleanBody = cleanBody.replace(/^On\s+.{10,80}\s+wrote:\s*$/m, '').trim();
    cleanBody = cleanBody.replace(/^From:\s+.+\nSent:\s+.+\nTo:\s+.+\n(Cc:\s+.+\n)?(Subject:\s+.+\n)?/m, '').trim();

    // Strip email signatures (-- followed by short block)
    cleanBody = cleanBody.replace(/\n--\s*\n[\s\S]{0,500}$/, '').trim();

    // Strip common disclaimers
    cleanBody = cleanBody.replace(/\n(DISCLAIMER|CONFIDENTIAL|This email.*confidential|This message.*intended)[\s\S]{0,2000}$/i, '').trim();

    // Strip trailing whitespace and excessive blank lines
    cleanBody = cleanBody.replace(/\n{3,}/g, '\n\n').trim();
    return cleanBody;
}
